<template>
    <IndexBase @auth="onAuth($event)" action="Index" controller="Dashboard"></IndexBase>
    <div class="grid" v-if="canView">
        <div class="card" v-if="is_wo">
              <h5 class="text-center mb-5">WO ORDER - ACTIVITY</h5>
        
                <div style=" text-align: right;">
                    <Calendar v-model="monthYear3" view="month" dateFormat="mm/yy" @date-select="onChangeMonthYear3($event && $event.value ? $event.value : $event)" placeholder="Choose Month year"/>
                </div>
                <div class="grid">

                    <div class="col-12 lg:col-6 xl:col-6">
                    <div class="card mb-0">
                        <div class="flex justify-content-between">
                            <div>
                                <div class="text-900 font-medium text-l">WO Created <span class="text-500">by {{ this.$store.getters.getFullname }}</span> </div>
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="col-12 lg:col-6 xl:col-6">
                    <div class="card mb-0">
                        <div class="flex justify-content-between">
                            <div>
                                <div class="text-900 font-medium text-l">WO Progress Updated <span class="text-500">by {{ this.$store.getters.getFullname }}</span></div>
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="col-12 lg:col-6 xl:col-3">
                    <div class="card mb-0">
                        <div class="flex justify-content-between mb-3">
                            <div>
                                <span class="block text-500 font-medium mb-3">Wo Creation</span> 
                                <div class="text-900 font-medium text-l">{{ (dataWO && dataWO.waiting_for_approval) || 0 }} Waiting For Approval</div>
                            </div>
                            <div class="flex align-items-center justify-content-center bg-orange-100 border-round" style="width: 2.5rem; height: 2.5rem">
                                <i class="pi pi-clock text-orange-500 text-xl"></i>
                            </div>
                        </div>
                        <span class="text-500">Outstanding</span>
                    </div>
                    </div>

                    <div class="col-12 lg:col-6 xl:col-3">
                        <div class="card mb-0">
                            <div class="flex justify-content-between mb-3">
                                <div>
                                    <span class="block text-500 font-medium mb-3">Wo Creation</span> 
                                    <div class="text-900 font-medium text-l">{{ (dataWO && dataWO.full_release) || 0 }} Full Release</div>
                                </div>
                                <div class="flex align-items-center justify-content-center bg-teal-100 border-round" style="width: 2.5rem; height: 2.5rem">
                                    <i class="pi pi-file text-teal-500 text-xl"></i>
                                </div>
                            </div>
                            <span class="text-500">{{ (dataWO && dataWO.close_release) || 0 }}  close this month</span>
                        </div>
                    </div>

                    <div class="col-12 lg:col-6 xl:col-3">
                        <div class="card mb-0">
                            <div class="flex justify-content-between mb-3">
                                <div>
                                    <span class="block text-500 font-medium mb-3">Wo Progressing</span> 
                                    <div class="text-900 font-medium text-l">{{ (dataWO && dataWO.in_progress) || 0 }} In Progress</div>
                                </div>
                                <div class="flex align-items-center justify-content-center bg-orange-100 border-round" style="width: 2.5rem; height: 2.5rem">
                                <i class="pi pi-clock text-orange-500 text-xl"></i>
                            </div>
                            </div>
                            <span class="text-500">Outstanding</span>
                        </div>
                    </div>

                    <div class="col-12 lg:col-6 xl:col-3">
                        <div class="card mb-0">
                            <div class="flex justify-content-between mb-3">
                                <div>
                                    <span class="block text-500 font-medium mb-3">Wo Progressing</span> 
                                    <div class="text-900 font-medium text-l">{{ (dataWO && dataWO.submit) || 0 }} Submit</div>
                                </div>
                                <div class="flex align-items-center justify-content-center bg-teal-100 border-round" style="width: 2.5rem; height: 2.5rem">
                                    <i class="pi pi-file text-teal-500 text-xl"></i>
                                </div>
                            </div>
                            <span class="text-500">{{ (dataWO && dataWO.close_progressing) || 0 }} Done this month</span>
                        </div>
                    </div>
                </div>
            </div>
        <div class="card">
            <div class="col-12">
                <div class="filter-row">
                    <div class="filter-item">
                        <label class="filter-label">{{$t('periodFrom')}}</label>
                        <div style="flex:1; min-width:0;">
                            <Calendar class="full-width" v-model="monthYearFrom" view="month" dateFormat="mm/yy" @date-select="onChangeMonthYearFrom()" placeholder="Choose Month year"/>
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">{{$t('periodTo')}}</label>
                        <div style="flex:1; min-width:0;">
                            <Calendar class="full-width" v-model="monthYearTo" view="month" dateFormat="mm/yy" @date-select="onChangeMonthYearTo()" placeholder="Choose Month year"/>
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">{{$t('location')}}</label>
                        <div style="flex:1; min-width:0;">
                            <CustomSelect ref="locationSelect1" class="full-width" name="location" :filter="true"
                                v-model="location_code" required="true"
                                placeholder="Please Select"
                                :url="$API_URL + 'list/location_code'"
                                :minLength="0"
                                :params="{isAuth : true}"
                                @change="onLocationChange" />
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">{{$t('company')}}</label>
                        <div style="flex:1; min-width:0;">
                            <CustomSelect ref="companySelect" class="full-width" name="company" :filter="true"
                                v-model="company_code" required="true"
                                placeholder="Please Select"
                                :url="$API_URL + 'list/company_code'"
                                :minLength="0"
                                :params="{isAuth : true}"
                                @change="onCompanyChange" />
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="status-block" style="margin-top:1rem; padding:1rem; text-align:left; width:100%;">
                            <h2 class="mb-3">{{ statusTitle }}</h2>
                            <div class="pie-grid" style="margin-top:1.5rem; display:grid; grid-template-columns: repeat(2, 1fr); gap:1rem;">
                                <div class="card">
                                    <h3 style="text-align:center; margin-bottom:0.5rem;"><u>Work Order Created</u></h3>
                                    <Chart type="doughnut" :data="pieData.created" :options="pieOptions" />
                                    <div class="pie-legend" v-if="pieData.created && pieData.created.labels && pieData.created.labels.length" style="margin-top:0.75rem;">
                                        <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                            <thead>
                                                <tr style="color:#666; font-size:0.85rem;">
                                                    <th style="width:28px; padding:6px 4px;"></th>
                                                    <th style="text-align:left; padding:6px 8px;">Work Group</th>
                                                    <th style="text-align:right; padding:6px 8px; width:80px;">Count</th>
                                                    <th style="text-align:right; padding:6px 8px; width:60px;">%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(label, idx) in pieData.created.labels" :key="'created-'+idx" style="border-top:1px solid #e0e0e0;">
                                                    <td style="width:28px; padding:6px 4px; vertical-align:middle;"><div :style="{width:'20px', height:'12px', background: (pieData.created.datasets && pieData.created.datasets[0] && pieData.created.datasets[0].backgroundColor ? pieData.created.datasets[0].backgroundColor[idx] : '#ccc'), border:'1px solid #999'}"></div></td>
                                                    <td style="padding:6px 8px; vertical-align:middle;">{{ label }}</td>
                                                    <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:80px;">{{ (pieData.created.datasets && pieData.created.datasets[0] && pieData.created.datasets[0].data[idx]) || 0 }}</td>
                                                    <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:60px;">{{ getPiePercent(pieData.created, idx) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card">
                                    <h3 style="text-align:center; margin-bottom:0.5rem;"><u>Work Order On Progress</u></h3>
                                    <Chart type="doughnut" :data="pieData.onprogress" :options="pieOptions" />
                                        <div class="pie-legend" v-if="pieData.onprogress && pieData.onprogress.labels && pieData.onprogress.labels.length" style="margin-top:0.75rem;">
                                            <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                                <thead>
                                                    <tr style="color:#666; font-size:0.85rem;">
                                                        <th style="width:28px; padding:6px 4px;"></th>
                                                        <th style="text-align:left; padding:6px 8px;">Work Group</th>
                                                        <th style="text-align:right; padding:6px 8px; width:80px;">Count</th>
                                                        <th style="text-align:right; padding:6px 8px; width:60px;">%</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(label, idx) in pieData.onprogress.labels" :key="'onprogress-'+idx" style="border-top:1px solid #e0e0e0;">
                                                        <td style="width:28px; padding:6px 4px; vertical-align:middle;"><div :style="{width:'20px', height:'12px', background: (pieData.onprogress.datasets && pieData.onprogress.datasets[0] && pieData.onprogress.datasets[0].backgroundColor ? pieData.onprogress.datasets[0].backgroundColor[idx] : '#ccc'), border:'1px solid #999'}"></div></td>
                                                        <td style="padding:6px 8px; vertical-align:middle;">{{ label }}</td>
                                                        <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:80px;">{{ (pieData.onprogress.datasets && pieData.onprogress.datasets[0] && pieData.onprogress.datasets[0].data[idx]) || 0 }}</td>
                                                        <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:60px;">{{ getPiePercent(pieData.onprogress, idx) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                </div>
                                <div class="card">
                                    <h3 style="text-align:center; margin-bottom:0.5rem;"><u>On Progress by Execution</u></h3>
                                    <Chart type="doughnut" :data="pieData.onprogressExecution" :options="pieOptions" />
                                        <div class="pie-legend" v-if="pieData.onprogressExecution && pieData.onprogressExecution.labels && pieData.onprogressExecution.labels.length" style="margin-top:0.75rem;">
                                            <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                                <thead>
                                                    <tr style="color:#666; font-size:0.85rem;">
                                                        <th style="width:28px; padding:6px 4px;"></th>
                                                        <th style="text-align:left; padding:6px 8px;">Work Group</th>
                                                        <th style="text-align:right; padding:6px 8px; width:80px;">Count</th>
                                                        <th style="text-align:right; padding:6px 8px; width:60px;">%</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(label, idx) in pieData.onprogressExecution.labels" :key="'onprogressExecution-'+idx" style="border-top:1px solid #e0e0e0;">
                                                        <td style="width:28px; padding:6px 4px; vertical-align:middle;"><div :style="{width:'20px', height:'12px', background: (pieData.onprogressExecution.datasets && pieData.onprogressExecution.datasets[0] && pieData.onprogressExecution.datasets[0].backgroundColor ? pieData.onprogressExecution.datasets[0].backgroundColor[idx] : '#ccc'), border:'1px solid #999'}"></div></td>
                                                        <td style="padding:6px 8px; vertical-align:middle;">{{ label }}</td>
                                                        <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:80px;">{{ (pieData.onprogressExecution.datasets && pieData.onprogressExecution.datasets[0] && pieData.onprogressExecution.datasets[0].data[idx]) || 0 }}</td>
                                                        <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:60px;">{{ getPiePercent(pieData.onprogressExecution, idx) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                </div>
                                <div class="card">
                                    <h3 style="text-align:center; margin-bottom:0.5rem;"><u>Work Order Completed</u></h3>
                                    <Chart type="doughnut" :data="pieData.completed" :options="pieOptions" />
                                        <div class="pie-legend" v-if="pieData.completed && pieData.completed.labels && pieData.completed.labels.length" style="margin-top:0.75rem;">
                                            <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                                <thead>
                                                    <tr style="color:#666; font-size:0.85rem;">
                                                        <th style="width:28px; padding:6px 4px;"></th>
                                                        <th style="text-align:left; padding:6px 8px;">Work Group</th>
                                                        <th style="text-align:right; padding:6px 8px; width:80px;">Count</th>
                                                        <th style="text-align:right; padding:6px 8px; width:60px;">%</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <tr v-for="(label, idx) in pieData.completed.labels" :key="'completed-'+idx" style="border-top:1px solid #e0e0e0;">
                                                        <td style="width:28px; padding:6px 4px; vertical-align:middle;"><div :style="{width:'20px', height:'12px', background: (pieData.completed.datasets && pieData.completed.datasets[0] && pieData.completed.datasets[0].backgroundColor ? pieData.completed.datasets[0].backgroundColor[idx] : '#ccc'), border:'1px solid #999'}"></div></td>
                                                        <td style="padding:6px 8px; vertical-align:middle;">{{ label }}</td>
                                                        <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:80px;">{{ (pieData.completed.datasets && pieData.completed.datasets[0] && pieData.completed.datasets[0].data[idx]) || 0 }}</td>
                                                        <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:60px;">{{ getPiePercent(pieData.completed, idx) }}</td>
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                </div>

                            </div>
                        </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="canView">
            <div class="col-12">
                <div class="filter-row">
                    <div class="filter-item">
                        <label class="filter-label">{{$t('location')}}</label>
                        <div style="flex:1; min-width:0;">
                            <CustomSelect ref="locationSelect2" class="full-width" name="location" :filter="true"
                                v-model="location_code2" required="true"
                                placeholder="Please Select"
                                :url="$API_URL + 'list/location_code'"
                                :minLength="0"
                                :params="{isAuth : true}"
                                @change="onLocationChange2" />
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">{{$t('company')}}</label>
                        <div style="flex:1; min-width:0;">
                            <CustomSelect ref="companySelect" class="full-width" name="company" :filter="true"
                                v-model="company_code2" required="true"
                                placeholder="Please Select"
                                :url="$API_URL + 'list/company_code'"
                                :minLength="0"
                                :params="{isAuth : true}"
                                @change="onCompanyChange2" />
                        </div>
                    </div>
                </div>
                <div class="col-12" v-if="canView">
                    <div class="status-block" style="margin-top:1rem; padding:1rem; text-align:left; width:100%;">
                            <h2 class="mb-3">{{statusTitle2 }}</h2>
                            <div class="pie-grid" style="margin-top:1.5rem; display:grid; grid-template-columns: repeat(2, 1fr); gap:1rem;">
                                <div class="card">
                                    <h3 style="text-align:center; margin-bottom:0.5rem;"><u>Work Order on Progress</u></h3>
                                    <Chart type="doughnut" :data="pieData.dataOutstandingWO" :options="pieOptions" />
                                    <div class="pie-legend" v-if="pieData.dataOutstandingWO && pieData.dataOutstandingWO.labels && pieData.dataOutstandingWO.labels.length" style="margin-top:0.75rem;">
                                        <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                            <thead>
                                                <tr style="color:#666; font-size:0.85rem;">
                                                    <th style="width:28px; padding:6px 4px;"></th>
                                                    <th style="text-align:left; padding:6px 8px;">Work Group</th>
                                                    <th style="text-align:right; padding:6px 8px; width:80px;">Count</th>
                                                    <th style="text-align:right; padding:6px 8px; width:60px;">%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(label, idx) in pieData.dataOutstandingWO.labels" :key="'outstanding-'+idx" style="border-top:1px solid #e0e0e0;">
                                                    <td style="width:28px; padding:6px 4px; vertical-align:middle;"><div :style="{width:'20px', height:'12px', background: (pieData.dataOutstandingWO.datasets && pieData.dataOutstandingWO.datasets[0] && pieData.dataOutstandingWO.datasets[0].backgroundColor ? pieData.dataOutstandingWO.datasets[0].backgroundColor[idx] : '#ccc'), border:'1px solid #999'}"></div></td>
                                                    <td style="padding:6px 8px; vertical-align:middle;">{{ label }}</td>
                                                    <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:80px;">{{ (pieData.dataOutstandingWO.datasets && pieData.dataOutstandingWO.datasets[0] && pieData.dataOutstandingWO.datasets[0].data[idx]) || 0 }}</td>
                                                    <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:60px;">{{ getPiePercent(pieData.dataOutstandingWO, idx) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div class="card">
                                    <h3 style="text-align:center; margin-bottom:0.5rem;"><u>Work Order on Progress (Tendering Status)</u></h3>
                                    <Chart type="doughnut" :data="pieData.dataOutstandingExecution" :options="pieOptions" />
                                    <div class="pie-legend" v-if="pieData.dataOutstandingExecution && pieData.dataOutstandingExecution.labels && pieData.dataOutstandingExecution.labels.length" style="margin-top:0.75rem;">
                                        <table style="width:100%; border-collapse:collapse; font-size:0.9rem;">
                                            <thead>
                                                <tr style="color:#666; font-size:0.85rem;">
                                                    <th style="width:28px; padding:6px 4px;"></th>
                                                    <th style="text-align:left; padding:6px 8px;">Work Group</th>
                                                    <th style="text-align:right; padding:6px 8px; width:80px;">Count</th>
                                                    <th style="text-align:right; padding:6px 8px; width:60px;">%</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(label, idx) in pieData.dataOutstandingExecution.labels" :key="'outExec-'+idx" style="border-top:1px solid #e0e0e0;">
                                                    <td style="width:28px; padding:6px 4px; vertical-align:middle;"><div :style="{width:'20px', height:'12px', background: (pieData.dataOutstandingExecution.datasets && pieData.dataOutstandingExecution.datasets[0] && pieData.dataOutstandingExecution.datasets[0].backgroundColor ? pieData.dataOutstandingExecution.datasets[0].backgroundColor[idx] : '#ccc'), border:'1px solid #999'}"></div></td>
                                                    <td style="padding:6px 8px; vertical-align:middle;">{{ label }}</td>
                                                    <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:80px;">{{ (pieData.dataOutstandingExecution.datasets && pieData.dataOutstandingExecution.datasets[0] && pieData.dataOutstandingExecution.datasets[0].data[idx]) || 0 }}</td>
                                                    <td style="padding:6px 8px; vertical-align:middle; text-align:right; width:60px;">{{ getPiePercent(pieData.dataOutstandingExecution, idx) }}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="card" v-if="canView">
            <div class="col-12">
                <div class="filter-row">
                    <div class="filter-item">
                        <label class="filter-label">{{$t('periodFrom')}}</label>
                        <div style="flex:1; min-width:0;">
                            <Calendar class="full-width" v-model="monthYearFrom2" view="month" dateFormat="mm/yy" @date-select="onChangeMonthYearFrom2()" placeholder="Choose Month year"/>
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">{{$t('periodTo')}}</label>
                        <div style="flex:1; min-width:0;">
                            <Calendar class="full-width" v-model="monthYearTo2" view="month" dateFormat="mm/yy" @date-select="onChangeMonthYearTo2()" placeholder="Choose Month year"/>
                        </div>
                    </div>
                    <div class="filter-item">
                        <label class="filter-label">{{$t('location')}}</label>
                        <div style="flex:1; min-width:0;">
                            <CustomSelect ref="locationSelect3" class="full-width" name="location" :filter="true"
                                v-model="location_code3" required="true"
                                placeholder="Please Select"
                                :url="$API_URL + 'list/location_code'"
                                :minLength="0"
                                :params="{isAuth : true}"
                                @change="onLocationChange3" />
                        </div>
                    </div>

                    <div class="filter-item">
                        <label class="filter-label">{{$t('company')}}</label>
                        <div style="flex:1; min-width:0;">
                            <CustomSelect ref="companySelect" class="full-width" name="company" :filter="true"
                                v-model="company_code3" required="true"
                                placeholder="Please Select"
                                :url="$API_URL + 'list/company_code'"
                                :minLength="0"
                                :params="{isAuth : true}"
                                @change="onCompanyChange3" />
                        </div>
                    </div>
                </div>
                <div class="filter-row" style="margin-top:1rem;">
                    <div class="filter-item">
                            <label class="filter-label">Document</label>
                            <div style="flex:1; min-width:0;">
                                <MultiSelect class="full-width" v-model="selectedDocTypes"
                                    :options="documentOptions"
                                    optionLabel="text"
                                    optionValue="id"
                                    display="chip"
                                    :filter="true"
                                    @change="onDocTypesChange" />
                            </div>
                    </div>
                </div>
                <div class="col-12">
                    <h2 class="mb-3">{{ statusTitle3 }}</h2>
                    <div class="two-cols" style="display:grid !important; grid-template-columns: repeat(2, 1fr) !important; gap:1rem !important; align-items:start !important;">
                        <div class="col-block">
                            <div class="status-block" style="margin-top:1rem; padding:1rem; text-align:left; width:100%;">
                                <h2 class="mb-3" style="text-align: center;"><u>Document Creation</u></h2>
                                <div class="document-chart-wrapper" style="margin-top:1rem;">
                                    <Chart type="bar" :data="documentChartData" :options="documentChartOptions" />
                                </div>
                            </div>
                        </div>
                        <div class="col-block">
                            <div class="status-block" style="margin-top:1rem; padding:1rem; text-align:right; width:100%;">
                                <h2 class="mb-3" style="text-align: center;"><u>Document on Progress</u></h2>
                                <div class="document-onprogress-chart-wrapper" style="margin-top:1rem;">
                                    <Chart type="bar" :data="documentOnProgressChartData" :options="documentChartOptions" />
                                </div>
                            </div>
                        </div>
                        <!-- Place Total & Total_Hari below the two charts, spanning both columns -->
                        <div class="col-block" style="grid-column: 1 / -1;">
                            <div class="status-block" style="margin-top:1rem; padding:1rem; text-align:center; width:100%;">
                                <h2 class="mb-3" style="text-align: center;"><u>Document Completed & Duration</u></h2>
                                <div class="document-total-days-chart-wrapper" style="margin-top:1rem;">
                                    <Chart type="bar" :data="documentTotalAndDaysChartData" :options="documentTotalDaysChartOptions" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
    
    <script>
    import IndexBase from '../Helper/IndexBase.vue'
    import {Chart} from 'chart.js';
    import ChartDataLabels from 'chartjs-plugin-datalabels';
        export default {
            name: 'DashboardIndex',
            props: {
                msg: String
            },
            components: {
                'IndexBase': IndexBase
            },
            data(){
                return{
                    dataUrl: "dashboard/",
                    basicData: null,
                    basicOptions: {
                        plugins: {
                            legend: {
                                labels: {
                                    color: '#495057'
                                }
                            },
                            datalabels: {
                                color: 'white',
                                formatter: (value, context) => {
                                return null;
                            }
                        }
                        },
                        scales: {
                            x: {
                                ticks: {
                                    color: '#495057'
                                },
                                grid: {
                                    color: '#ebedef'
                                }
                            },
                            y: {
                                ticks: {
                                    color: '#495057'
                                },
                                grid: {
                                    color: '#ebedef'
                                }
                            }
                        }
                    },
                    loading : false,
                    location_code : this.$store.getters.getLocation,
                    company_code : null,
                    location_code2 : this.$store.getters.getLocation,
                    company_code2 : null,
                    location_code3 : this.$store.getters.getLocation,
                    company_code3 : null,
                    dataWO : {},
                    selectedDocTypes: ['1','10','11','17','18'],
                    documentOptions: [
                        { id: '1', text: 'MC-0' },
                        { id: '2', text: 'Addendum MC-0' },
                        { id: '3', text: 'BAIK With SPO' },
                        { id: '4', text: 'BAIK Without SPO' },
                        { id: '5', text: 'KoM' },
                        { id: '6', text: 'Progress Termin' },
                        { id: '7', text: 'BAST Termin' },
                        { id: '8', text: 'MC In Between' },
                        { id: '9', text: 'Addendum MC-In Between' },
                        { id: '10', text: 'MC-100' },
                        { id: '11', text: 'Addendum MC-100' },
                        { id: '12', text: 'KoM QC' },
                        { id: '13', text: 'Final QC' },
                        { id: '14', text: 'Delay' },
                        { id: '15', text: 'Penalty' },
                        { id: '16', text: 'Progress Final' },
                        { id: '17', text: 'BAST Final' },
                        { id: '18', text: 'BAST Retensi' }
                    ],
                    loadingChart: false,
                    month : null,
                    filters: {},
                    listmonth:[
                        { id: 1, name: 'Januari' },
                        { id: 2, name: 'Februari' },
                        { id: 3, name: 'Maret' },
                        { id: 4, name: 'April' },
                        { id: 5, name: 'Mei' },
                        { id: 6, name: 'Juni' },
                        { id: 7, name: 'Juli' },
                        { id: 8, name: 'Agustus' },
                        { id: 9, name: 'September' },
                        { id: 10, name: 'Oktober' },
                        { id: 11, name: 'November' },
                        { id: 12, name: 'Desember' },
                    ],
                    canCreate: false,
                    canEdit: false,
                    canDelete: false,
                    canView: false,
                    canPrint: false,
                    basicOptionsChar : {
                        plugins: {
                        datalabels: {
                            color: 'white',
                            formatter: (value, context) => {
                            return value;
                            }
                        }
                        }
                    },
                    pieData: {
                        created: null,
                        completed: null,
                        onprogress: null,
                        onprogressExecution: null,
                        dataOutstandingWO : null,
                        dataOutstandingExecution : null
                    },
                    pieOptions: {
                        responsive: true,
                        maintainAspectRatio: false,
                        cutout: '55%',
                        plugins: {
                            legend: { display: false },
                            datalabels: {
                                color: '#fff',
                                anchor: 'center',
                                align: 'center',
                                clamp: true,
                                formatter: (value, ctx) => {
                                    const ds = ctx.dataset || {};
                                    const idx = ctx.dataIndex;
                                    if (ds._percent && ds._percent[idx] !== undefined && ds._percent[idx] !== '') {
                                        return String(ds._percent[idx]) + '%';
                                    }
                                    const total = (ds.data || []).reduce((s, v) => s + (Number(v) || 0), 0);
                                    if (!total) return '';
                                    const raw = (ds.data && ds.data[idx] !== undefined) ? Number(ds.data[idx]) : 0;
                                    return Math.round(((raw||0) / total) * 100) + '%';
                                },
                                font: { weight: '600' }
                            }
                        }
                    },
                    // Document charts
                    documentChartData: { labels: [], datasets: [{ data: [], backgroundColor: [] }] },
                    documentOnProgressChartData: { labels: [], datasets: [{ data: [], backgroundColor: [] }] },
                    // Chart for Total & Total_Hari per document
                    documentTotalAndDaysChartData: { labels: [], datasets: [] },
                    documentTotalDaysChartOptions: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: { display: true, position: 'top' },
                            // show raw value in tooltip but datalabels/axis will show integer display values
                            tooltip: {
                                callbacks: {
                                    label: function(ctx) {
                                        const ds = ctx.dataset || {};
                                        const idx = ctx.dataIndex;
                                        const raw = (ds._rawData && ds._rawData[idx] !== undefined) ? ds._rawData[idx] : (ctx.parsed && ctx.parsed.y !== undefined ? ctx.parsed.y : ctx.raw);
                                        const label = ds.label ? ds.label + ': ' : '';
                                        if (typeof raw === 'number') return label + raw;
                                        return label + String(raw);
                                    }
                                }
                            },
                            datalabels: {
                                color: '#fff',
                                anchor: 'center',
                                align: 'center',
                                clamp: true,
                                formatter: (value, ctx) => {
                                    if (value === null || value === undefined) return '';
                                    const n = Number(value);
                                    if (!isFinite(n)) return value;
                                    return Math.round(n);
                                },
                                font: { weight: '600' }
                            }
                        },
                        scales: {
                            y: {
                                beginAtZero: true,
                                suggestedMin: 0,
                                ticks: { stepSize: 1, callback: function(value) { if (typeof value === 'number' && isFinite(value)) return Math.round(value); return value; } }
                            }
                        }
                    },
                    documentChartOptions: {
                        responsive: true,
                        maintainAspectRatio: false,
                        plugins: {
                            legend: { display: false },
                            datalabels: {
                                color: '#fff',
                                anchor: 'center',
                                align: 'center',
                                clamp: true,
                                formatter: (value, ctx) => {
                                    // show 0 and other numeric values; hide only null/undefined
                                    if (value === null || value === undefined) return '';
                                    const n = Number(value);
                                    if (!isFinite(n)) return value;
                                    return Math.round(n);
                                },
                                font: { weight: '600' }
                            }
                        },
                        scales: {
                            y: {
                                beginAtZero: true,
                                suggestedMin: 0,
                                ticks: {
                                    // Force ticks to be integer steps (0,1,2...)
                                    stepSize: 1,
                                    callback: function(value) {
                                        if (typeof value === 'number' && isFinite(value)) return Math.round(value);
                                        return value;
                                    }
                                }
                            }
                        }
                    },
                    monthYearFrom: new Date(),
                    monthYearTo: null,

                    monthYearFrom2: new Date(),
                    monthYearTo2: null,
                    monthYear3 : new Date(),
                    location_label: '',
                    location_label3: '',
                    _lastOutstandingKey: null,
                    _outstandingController: null,
                    _outstandingTimer: null,
                    is_wo: false,
                    is_pm : this.$store.getters.getJobPosition.includes(this.$UserLevel.PROJECT_MANAGER)
                }
            },
            computed: {
                statusTitle() {
                    const From = this.monthYearFrom;
                    let monthNameFrom = '';
                    let yearFrom = '';

                    const To = this.monthYearTo;
                    let monthNameTo = '';
                    let yearTo = '';

                    if (From && From instanceof Date && !isNaN(From)) {
                        monthNameFrom = this.listmonth[From.getMonth()] ? this.listmonth[From.getMonth()].name : From.toLocaleString(undefined, { month: 'long' });
                        yearFrom = From.getFullYear();
                    }

                    if (To && To instanceof Date && !isNaN(To)) {
                        monthNameTo = this.listmonth[To.getMonth()] ? this.listmonth[To.getMonth()].name : To.toLocaleString(undefined, { month: 'long' });
                        yearTo = To.getFullYear();
                    }

                    const loc = this.location_label ? (' - ' + this.location_label) : '';
                    const hasFrom =  monthNameFrom + ' ' + yearFrom;
                    const hasTo =  monthNameTo ? (' - ' + monthNameTo + ' ' + yearTo) : '';

                    return `Status of Work Order Created in ${hasFrom} ${hasTo} ${loc}`.trim();
                },
                statusTitle2() {
                    const d = new Date();
                    let monthName = '';
                    let year = '';
                    let date = '';
                    if (d && d instanceof Date && !isNaN(d)) {
                        monthName = this.listmonth[d.getMonth()] ? this.listmonth[d.getMonth()].name : d.toLocaleString(undefined, { month: 'long' });
                        year = d.getFullYear();
                        date = d.getDate();
                    }
                    return `Status of Work Order Created until ${date} ${monthName} ${year}`.trim();
                },
                statusTitle3() {
                    const from = this.monthYearFrom2;
                    let monthNameFrom = '';
                    let yearFrom = '';
                    if (from && from instanceof Date && !isNaN(from)) {
                        monthNameFrom = this.listmonth[from.getMonth()] ? this.listmonth[from.getMonth()].name : from.toLocaleString(undefined, { month: 'long' });
                        yearFrom = from.getFullYear();
                    }
                    const to = this.monthYearTo2;
                    let monthNameTo = '';
                    let yearTo = '';
                    if (to && to instanceof Date && !isNaN(to)) {
                        monthNameTo = this.listmonth[to.getMonth()] ? this.listmonth[to.getMonth()].name : to.toLocaleString(undefined, { month: 'long' });
                        yearTo = to.getFullYear();
                    }

                    const loc = this.location_label3 ? (' - ' + this.location_label3) : '';
                    const hasFrom =  monthNameFrom + ' ' + yearFrom;
                    const hasTo =  monthNameTo ? (' - ' + monthNameTo + ' ' + yearTo) : '';
                    return `Status of Document Created in ${hasFrom}${hasTo}${loc}`.trim();
                },
            },
            methods:{
                onAuth(event) {
                    this.canCreate = event.canCreate;
                    this.canEdit = event.canEdit;
                    this.canDelete = event.canDelete;
                    this.canView = event.canView;
                    this.canPrint = event.canPrint;
                    var listTransactionCreate = this.$store.getters.getListTransactionCreate;
                    var listTransactionEdit = this.$store.getters.getListTransactionEdit;
                    this.is_wo = listTransactionCreate.includes('Work Order Creation') || listTransactionEdit.includes('Work Order Progressing');
                },
                async onLocationChange(selected){
                    if(selected && typeof selected === 'object'){
                        this.location_code = selected.value || selected.code || this.location_code;
                        if(selected.label || selected.text) {
                            this.location_label = selected.label || selected.text;
                        } else if(selected.name && (selected.code || selected.value)){
                            const code = selected.code || selected.value;
                            this.location_label = `[${code}] ${selected.name}`;
                        } else {
                            this.location_label = selected.name || '';
                        }
                    } else {
                        this.location_code = selected;
                        await this.fetchLocationLabel(selected);
                    }
                    this.triggerGetProgressWO(0);
                },
                async onCompanyChange(selected){
                    if(selected && typeof selected === 'object'){
                        this.company_code = selected.value || selected.code || this.company_code;
                    } else {
                        this.company_code = selected;
                    }
                },
                async onLocationChange2(selected){
                    if(selected && typeof selected === 'object'){
                        this.location_code2 = selected.value || selected.code || this.location_code2;
                    } else {
                        this.location_code2 = selected;
                    }
                    this.triggerGetOutstandingWO(0);
                },
                async onCompanyChange2(selected){
                    if(selected && typeof selected === 'object'){
                        this.company_code2 = selected.value || selected.code || this.company_code2;
                    } else {
                        this.company_code2 = selected;
                    }
                    // trigger outstanding data refresh when company2 changes
                    this.triggerGetOutstandingWO(0);
                },                
                async onLocationChange3(selected){
                    if(selected && typeof selected === 'object'){
                        this.location_code3 = selected.value || selected.code || this.location_code3;
                        if(selected.label || selected.text) {
                            this.location_label3 = selected.label || selected.text;
                        } else if(selected.name && (selected.code || selected.value)){
                            const code = selected.code || selected.value;
                            this.location_label3 = `[${code}] ${selected.name}`;
                        } else {
                            this.location_label3 = selected.name || '';
                        }
                    } else {
                        this.location_code3 = selected;
                        await this.fetchLocationLabel3(selected);
                    }
                    this.triggerGetProgressDocument(0);
                },
                async onCompanyChange3(selected){
                    if(selected && typeof selected === 'object'){
                        this.company_code3 = selected.value || selected.code || this.company_code3;
                    } else {
                        this.company_code3 = selected;
                    }
                    // trigger document refresh when company3 changes
                    this.triggerGetProgressDocument(0);
                },
                    onDocTypesChange(selected){
                        // `selected` can be an event object ({ originalEvent, value }) from our MultiSelect
                        const val = selected && selected.value !== undefined ? selected.value : selected;
                        this.selectedDocTypes = Array.isArray(val) ? val : (val ? [val] : []);
                        // trigger document refresh if handler exists
                        if (typeof this.getProgressDocument === 'function') {
                            try{ this.triggerGetProgressDocument(0); }catch(e){ console.error(e); }
                        } else {
                        }
                    },
                // Called by the Calendar date-select — ensure change triggers refresh
                onChangeMonthYearTo(selected){
                    if(selected && selected instanceof Date && !isNaN(selected)){
                        this.monthYearTo = selected;
                    }
                    this.triggerGetProgressWO();
                },
                onChangeMonthYearFrom(selected){
                    if(selected && selected instanceof Date && !isNaN(selected)){
                        this.monthYearFrom = selected;
                    }
                    this.triggerGetProgressWO();
                },
                onChangeMonthYearFrom2(selected){
                    if(selected && selected instanceof Date && !isNaN(selected)){
                        this.monthYearFrom2 = selected;
                    }
                    this.triggerGetProgressDocument();
                },
                onChangeMonthYearTo2(selected){
                    if(selected && selected instanceof Date && !isNaN(selected)){
                        this.monthYearTo2 = selected;
                    }
                    this.triggerGetProgressDocument();
                },
                onChangeMonthYear3(selected){
                    if(selected && selected instanceof Date && !isNaN(selected)){
                        this.monthYear3 = selected;
                        this.getPemerosesanDocumentWo();
                    }
                },
                // Optional: function to resolve label from server when only code is emitted
               async fetchLocationLabel(code){
                    if(!code){
                        this.location_label = '';
                        return;
                    }
                    try{
                        // Build params similar to CustomSelect.onInit (q + init)
                        const child = this.$refs.locationSelect1;
                        const fParams = { q: code, page: 0, init: true };
                        if(child && child.params){
                            Object.assign(fParams, child.params);
                        }

                        const res = await this.$axios.get(this.$API_URL + 'list/location_code', { params: fParams });
                        // Expecting response.data.items (same as CustomSelect)
                        if(res && res.data && Array.isArray(res.data.items) && res.data.items.length > 0){
                            const item = res.data.items[0];
                            // sync child dataModel so dropdown shows full value
                            if(child){
                                child.dataModel = item;
                            }

                            if(item.label || item.text) {
                                this.location_label = item.label || item.text;
                            } else if(item.name && (item.code || item.value || item.id)){
                                const c = item.code || item.value || item.id;
                                this.location_label = `[${c}] ${item.name}`;
                            } else if(item.code && item.name){
                                this.location_label = `[${item.code}] ${item.name}`;
                            } else {
                                this.location_label = item.name || item.label || code;
                            }
                        } else {
                            this.location_label = code;
                        }
                    }catch(e){
                        this.location_label = code;
                    }
                },
               async fetchLocationLabel3(code){
                    if(!code){
                        this.location_label3 = '';
                        return;
                    }
                    try{
                        // Build params similar to CustomSelect.onInit (q + init)
                        const child = this.$refs.locationSelect3;
                        const fParams = { q: code, page: 0, init: true };
                        if(child && child.params){
                            Object.assign(fParams, child.params);
                        }

                        const res = await this.$axios.get(this.$API_URL + 'list/location_code', { params: fParams });
                        // Expecting response.data.items (same as CustomSelect)
                        if(res && res.data && Array.isArray(res.data.items) && res.data.items.length > 0){
                            const item = res.data.items[0];
                            // sync child dataModel so dropdown shows full value
                            if(child){
                                child.dataModel = item;
                            }

                            if(item.label || item.text) {
                                this.location_label3 = item.label || item.text;
                            } else if(item.name && (item.code || item.value || item.id)){
                                const c = item.code || item.value || item.id;
                                this.location_label3 = `[${c}] ${item.name}`;
                            } else if(item.code && item.name){
                                this.location_label3 = `[${item.code}] ${item.name}`;
                            } else {
                                this.location_label3 = item.name || item.label || code;
                            }
                        } else {
                            this.location_label3 = code;
                        }
                    }catch(e){
                        this.location_label3 = code;
                    }
                },
                getPiePercent(pie, idx){
                    try{
                        if(!pie || !pie.datasets || !pie.datasets[0]) return '';
                        const ds = pie.datasets[0];
                        const raw = (ds.data && ds.data[idx] !== undefined) ? Number(ds.data[idx]) : 0;
                        if (ds._percent && ds._percent[idx] !== undefined && ds._percent[idx] !== '') return String(ds._percent[idx]) + '%';
                        const total = (ds.data || []).reduce((s, v) => s + (Number(v) || 0), 0);
                        if (!total) return '0%';
                        return Math.round((raw / total) * 100) + '%';
                    }catch(e){ return ''; }
                },
                
                // Fetch data for Progress WO pie chart with cancellation and caching
                async getProgressWO(){
                    this.loading = true;
                    const data = {
                        monthDateTo: this.monthYearTo,
                        monthDateFrom: this.monthYearFrom,
                        location_code: this.location_code,
                        company_code: this.company_code
                    };

                    // build a simple key to avoid re-requesting identical payloads
                    const monthKeyTo = (this.monthYearTo && this.monthYearTo instanceof Date) ? this.monthYearTo.toISOString().slice(0,7) : String(this.monthYearTo || '');
                    const monthKeyFrom = (this.monthYearFrom && this.monthYearFrom instanceof Date) ? this.monthYearFrom.toISOString().slice(0,7) : String(this.monthYearFrom || '');
                    const payloadKey = `${this.location_code || ''}::${monthKeyFrom}::${monthKeyTo}::${this.company_code || ''}`;
                    if (this._lastPayloadKey && this._lastPayloadKey === payloadKey) {
                        this.loading = false;
                        return; // nothing changed
                    }

                    // cancel previous request if still pending
                    try{
                        if (this._progressController) {
                            try{ this._progressController.abort(); } catch(e){}
                        }
                    }catch(e){}

                    // create AbortController for this request (axios supports `signal`)
                    try{ this._progressController = new AbortController(); } catch(e){ this._progressController = null; }

                    try{
                        const config = this._progressController ? { signal: this._progressController.signal } : {};
                        const response = await this.$axios.post(this.$API_URL + this.dataUrl + "ProgressWO", data, config);
                        if (response && response.data && response.data.success) {
                            const payload = response.data.data || {};
                            const parseArray = (v) => {
                                if (!v) return [];
                                try {
                                    if (typeof v === 'string') return JSON.parse(v);
                                    if (Array.isArray(v)) return v;
                                    return [];
                                } catch (e) { return [] }
                            }

                            const buildPie = (arr) => {
                                arr = Array.isArray(arr) ? arr : [];
                                const labels = arr.map(i => i.Work_Group || i.work_group || '');
                                const dataVals = arr.map(i => Number(i.Data_Value) || 0);
                                const percents = arr.map(i => {
                                    if (i.Percentage !== undefined && i.Percentage !== null) return Number(i.Percentage).toString();
                                    return '';
                                });
                                const palette = ['#4e79a7','#f28e2b','#e15759','#76b7b2','#59a14f','#edc949','#b07aa1','#ff9da7','#9c755f','#bab0ac'];
                                const backgroundColor = labels.map((_, idx) => palette[idx % palette.length]);
                                const ds = [{ data: dataVals, backgroundColor: backgroundColor }];
                                if (ds[0]) ds[0]._percent = percents;
                                return { labels: labels, datasets: ds };
                            }

                            this.pieData.created = buildPie(parseArray(payload.dataCreated));
                            this.pieData.completed = buildPie(parseArray(payload.dataCompleted));
                            this.pieData.onprogress = buildPie(parseArray(payload.dataOnProgress));
                            this.pieData.onprogressExecution = buildPie(parseArray(payload.dataOnProgressExecution));

                            // update cache key on success
                            this._lastPayloadKey = payloadKey;
                        } else if (response && response.data && response.data.message) {
                            this.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                    }catch(err){
                        // ignore canceled requests
                        const isCanceled = err && (err.name === 'CanceledError' || err.code === 'ERR_CANCELED' || err.message === 'canceled');
                        if (!isCanceled) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: err && err.message ? err.message : String(err), life: 120000});
                        }
                    }finally{
                        this.loading = false;
                        // clear controller reference
                        this._progressController = null;
                    }
                },

               async getOutStandingWO(){
                    this.loading = true;
                    const data = {
                        monthDate: this.monthYear,
                        location_code: this.location_code2,
                        company_code: this.company_code2
                    };

                    // build a simple key to avoid re-requesting identical payloads
                    const monthKey = (this.monthYear && this.monthYear instanceof Date) ? this.monthYear.toISOString().slice(0,7) : String(this.monthYear || '');
                    const payloadKey = `${this.location_code2 || ''}::${monthKey}::${this.company_code2 || ''}`;
                    if (this._lastOutstandingKey && this._lastOutstandingKey === payloadKey) {
                        this.loading = false;
                        return; // nothing changed
                    }

                    // cancel previous outstanding request if still pending
                    try{
                        if (this._outstandingController) {
                            try{ this._outstandingController.abort(); } catch(e){}
                        }
                    }catch(e){}

                    // create AbortController for this request (axios supports `signal`)
                    try{ this._outstandingController = new AbortController(); } catch(e){ this._outstandingController = null; }

                    try{
                        const config = this._outstandingController ? { signal: this._outstandingController.signal } : {};
                        const response = await this.$axios.post(this.$API_URL + this.dataUrl + "OutstandingWO", data, config);
                        if (response && response.data && response.data.success) {
                            const payload = response.data.data || {};
                            const parseArray = (v) => {
                                if (!v) return [];
                                try {
                                    if (typeof v === 'string') return JSON.parse(v);
                                    if (Array.isArray(v)) return v;
                                    return [];
                                } catch (e) { return [] }
                            }

                            const buildPie = (arr) => {
                                arr = Array.isArray(arr) ? arr : [];
                                const labels = arr.map(i => i.Work_Group || i.work_group || '');
                                const dataVals = arr.map(i => Number(i.Data_Value) || 0);
                                const percents = arr.map(i => {
                                    if (i.Percentage !== undefined && i.Percentage !== null) return Number(i.Percentage).toString();
                                    return '';
                                });
                                const palette = ['#4e79a7','#f28e2b','#e15759','#76b7b2','#59a14f','#edc949','#b07aa1','#ff9da7','#9c755f','#bab0ac'];
                                const backgroundColor = labels.map((_, idx) => palette[idx % palette.length]);
                                const ds = [{ data: dataVals, backgroundColor: backgroundColor }];
                                if (ds[0]) ds[0]._percent = percents;
                                return { labels: labels, datasets: ds };
                            }

                            this.pieData.dataOutstandingWO = buildPie(parseArray(payload.dataOutstandingWO));
                            this.pieData.dataOutstandingExecution = buildPie(parseArray(payload.dataOutstandingExecution));

                            // update cache key on success
                            this._lastOutstandingKey = payloadKey;
                        } else if (response && response.data && response.data.message) {
                            this.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                    }catch(err){
                        // ignore canceled requests
                        const isCanceled = err && (err.name === 'CanceledError' || err.code === 'ERR_CANCELED' || err.message === 'canceled');
                        if (!isCanceled) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: err && err.message ? err.message : String(err), life: 120000});
                        }
                    }finally{
                        this.loading = false;
                        // clear controller reference
                        this._outstandingController = null;
                    }
                },
                async getProgressDocument(){
                    this.loadingChart = true;
                    // normalize selectedDocTypes into a predictable array
                    const rawDocs = Array.isArray(this.selectedDocTypes) ? this.selectedDocTypes : (this.selectedDocTypes ? [this.selectedDocTypes] : []);
                    const normalizedDocs = rawDocs.map(v => (v === null || v === undefined) ? '' : String(v).trim()).filter(v => v !== '');
                    // keep document values as strings (server may expect strings) and also provide CSV fallback
                    const docsForPayloadStrings = normalizedDocs.map(v => String(v));
                    const docsCsv = docsForPayloadStrings.join(',');

                        const data = {
                        monthDateTo: this.monthYearTo2,
                        monthDateFrom: this.monthYearFrom2,
                        location_code: this.location_code3,
                        company_code: this.company_code3,
                        document: normalizedDocs
                    };
                    // debug: ensure payload contains document (strings + csv)

                    // build a simple key to avoid re-requesting identical payloads
                    const monthKeyTo = (this.monthYearTo2 && this.monthYearTo2 instanceof Date) ? this.monthYearTo2.toISOString().slice(0,7) : String(this.monthYearTo2 || '');
                    const monthKeyFrom = (this.monthYearFrom2 && this.monthYearFrom2 instanceof Date) ? this.monthYearFrom2.toISOString().slice(0,7) : String(this.monthYearFrom2 || '');
                    const payloadKey = `${this.location_code3 || ''}::${monthKeyFrom}::${monthKeyTo}::${this.company_code3 || ''}::${docsCsv}`;
                    if (this._lastDocumentKey && this._lastDocumentKey === payloadKey) {
                        this.loadingChart = false;
                        return; // nothing changed
                    }

                    // cancel previous document request if still pending
                    try{
                        if (this._documentController) {
                            try{ this._documentController.abort(); } catch(e){}
                        }
                    }catch(e){}

                    // create AbortController for this request (axios supports `signal`)
                    try{ this._documentController = new AbortController(); } catch(e){ this._documentController = null; }

                    try{
                        const config = this._documentController ? { signal: this._documentController.signal } : {};
                        const response = await this.$axios.post(this.$API_URL + this.dataUrl + "progresdocument", data, config);
                        if (response && response.data && response.data.success) {
                            const payload = response.data.data || response.data;

                            let arr = [];

                            // payload may already be an array
                            if (Array.isArray(payload)) arr = payload;

                            // try known keys that may contain JSON strings
                            if((!arr || !arr.length) && payload && typeof payload === 'object'){
                                if (Array.isArray(payload.data)) arr = payload.data;
                                else if (payload.dataCreateDocument) {
                                    try{ arr = JSON.parse(payload.dataCreateDocument); }catch(e){ arr = []; }
                                } else if (payload.dataDocument) {
                                    try{ arr = JSON.parse(payload.dataDocument); }catch(e){ arr = []; }
                                } else if (payload.dataChar) arr = payload.dataChar;
                            }

                            // fallback to response root keys
                            if((!arr || !arr.length) && response.data){
                                if(response.data.dataCreateDocument){
                                    try{ arr = JSON.parse(response.data.dataCreateDocument); }catch(e){ arr = []; }
                                }
                                if((!arr || !arr.length) && response.data.dataDocument){
                                    try{ arr = JSON.parse(response.data.dataDocument); }catch(e){ arr = []; }
                                }
                                if((!arr || !arr.length) && response.data.dataChar) arr = response.data.dataChar;
                            }

                            if (!Array.isArray(arr)) arr = [];

                            // normalize and sort by Ordinal if available
                            const normalized = arr.map(i => i || {});
                            if (normalized.some(i => i.Ordinal !== undefined)) {
                                normalized.sort((a,b) => (Number(a.Ordinal)||0) - (Number(b.Ordinal)||0));
                            }

                            const extractNumber = (obj, keys) => {
                                if (!obj) return 0;
                                for (let k of keys) {
                                    if (obj[k] !== undefined && obj[k] !== null) return Number(obj[k]);
                                }
                                return 0;
                            };
                            const labels = normalized.map(i => (i.Category ?? i.text ?? i.label ?? i.Label ?? i.Document ?? i.name ?? ''));
                            const values = normalized.map(i => extractNumber(i, ['Total','Value','count','Data_Value','total']));
                            // Fallback: if API returned no labels, use `documentOptions` (selected doc types or all) so labels still render
                            if ((!labels || !labels.length) && Array.isArray(this.documentOptions) && this.documentOptions.length) {
                                const docsToUse = (normalizedDocs && normalizedDocs.length) ? normalizedDocs.map(String) : this.documentOptions.map(o => String(o.id));
                                const fallbackLabels = this.documentOptions.filter(o => docsToUse.includes(String(o.id))).map(o => o.text || o.name || '');
                                if (fallbackLabels && fallbackLabels.length) {
                                    // override labels/values with fallback (zeros)
                                    labels.splice(0, labels.length, ...fallbackLabels);
                                    values.splice(0, values.length, ...fallbackLabels.map(() => 0));
                                }
                            }
                            const palette = ['#4e79a7','#f28e2b','#e15759','#76b7b2','#59a14f','#edc949','#b07aa1','#ff9da7','#9c755f','#bab0ac'];
                            const backgroundColor = labels.map((_, idx) => palette[idx % palette.length]);
                            this.documentChartData = { labels, datasets: [{ data: values, backgroundColor }] };

                            // Try to extract "dataOnProgressDocument" from response (same payload source)
                            let arrOn = [];
                            if (payload && payload.dataOnProgressDocument) {
                                try { arrOn = typeof payload.dataOnProgressDocument === 'string' ? JSON.parse(payload.dataOnProgressDocument) : payload.dataOnProgressDocument; } catch(e){ arrOn = payload.dataOnProgressDocument || []; }
                            }
                            if ((!arrOn || !arrOn.length) && response.data && response.data.dataOnProgressDocument) {
                                try{ arrOn = typeof response.data.dataOnProgressDocument === 'string' ? JSON.parse(response.data.dataOnProgressDocument) : response.data.dataOnProgressDocument; } catch(e){ arrOn = response.data.dataOnProgressDocument || []; }
                            }
                            if (!Array.isArray(arrOn)) arrOn = [];
                            const normalizedOn = arrOn.map(i => i || {});
                            if (normalizedOn.some(i => i.Ordinal !== undefined)) {
                                normalizedOn.sort((a,b) => (Number(a.Ordinal)||0) - (Number(b.Ordinal)||0));
                            }
                            // Build a map of on-progress values keyed by label
                            const onMap = {};
                            normalizedOn.forEach(item => {
                                const key = (item.Category ?? item.text ?? item.label ?? item.Label ?? item.Document ?? item.name ?? '').toString();
                                if (key) onMap[key] = extractNumber(item, ['Total','Value','count','Data_Value','total']);
                            });

                            // Use base labels from the main document chart when available
                            const baseLabels = (labels && labels.length) ? labels.slice() : (Array.isArray(this.documentOptions) ? this.documentOptions.map(o => o.text || '') : []);

                            // If neither baseLabels nor onMap keys exist, fall back to normalizedOn labels
                            let finalLabels = baseLabels && baseLabels.length ? baseLabels : Object.keys(onMap);
                            if ((!finalLabels || !finalLabels.length) && normalizedOn.length) {
                                finalLabels = normalizedOn.map(i => (i.Category ?? i.text ?? i.label ?? i.Label ?? i.Document ?? i.name ?? ''));
                            }

                            const finalValues = finalLabels.map(lbl => (Object.prototype.hasOwnProperty.call(onMap, lbl) ? onMap[lbl] : 0));
                            const backgroundColorOn = finalLabels.map((_, idx) => palette[idx % palette.length]);
                            this.documentOnProgressChartData = { labels: finalLabels, datasets: [{ data: finalValues, backgroundColor: backgroundColorOn }] };

                            // Prefer dataDurationDocument as source for Total values if present
                            let arrDuration = [];
                            if (payload && payload.dataDurationDocument) {
                                try { arrDuration = typeof payload.dataDurationDocument === 'string' ? JSON.parse(payload.dataDurationDocument) : payload.dataDurationDocument; } catch(e){ arrDuration = payload.dataDurationDocument || []; }
                            }
                            if ((!arrDuration || !arrDuration.length) && response.data && response.data.dataDurationDocument) {
                                try { arrDuration = typeof response.data.dataDurationDocument === 'string' ? JSON.parse(response.data.dataDurationDocument) : response.data.dataDurationDocument; } catch(e){ arrDuration = response.data.dataDurationDocument || []; }
                            }
                            if (!Array.isArray(arrDuration)) arrDuration = [];

                            const normalizedDuration = arrDuration.map(i => i || {});

                            const durationTotalVals = normalizedDuration.length ? normalizedDuration.map(i => extractNumber(i, ['Total','total','Value','Data_Value','count'])) : null;
                            const durationTotalHariVals = normalizedDuration.length ? normalizedDuration.map(i => extractNumber(i, ['Total_Hari','TotalHari','total_hari','Days','Hari'])) : null;

                            // Use duration arrays if available, otherwise fall back to main normalized data
                            const finalLabelsForTotal = (normalizedDuration.length ? normalizedDuration.map(i => (i.Category ?? i.text ?? i.label ?? i.Label ?? i.Document ?? i.name ?? '')) : labels);
                            const finalTotalVals = Array.isArray(durationTotalVals) ? durationTotalVals : normalized.map(i => extractNumber(i, ['Total','total','Value','Data_Value','count']));
                            const finalTotalHariVals = Array.isArray(durationTotalHariVals) ? durationTotalHariVals : normalized.map(i => extractNumber(i, ['Total_Hari','TotalHari','total_hari','Days','Hari']));

                            const dsTotal = { label: 'Count of Document', data: finalTotalVals, backgroundColor: '#4e79a7' };
                            // preserve raw Total_Hari values but display rounded-up integers on chart
                            const rawTotalHari = Array.isArray(finalTotalHariVals) ? finalTotalHariVals : [];
                            const displayTotalHari = rawTotalHari.map(v => {
                                const n = Number(v);
                                if (!isFinite(n) || n === 0) return 0;
                                return Math.ceil(n);
                            });
                            const dsTotalHari = { label: 'Average of Duration (Days)', data: displayTotalHari, backgroundColor: '#f28e2b', _rawData: rawTotalHari };
                            this.documentTotalAndDaysChartData = { labels: finalLabelsForTotal, datasets: [dsTotal, dsTotalHari] };

                            // update cache key on success
                            this._lastDocumentKey = payloadKey;
                        } else if (response && response.data && response.data.message) {
                            this.$toast.add({ severity: 'error', summary: "Error", detail: response.data.message, life: 120000});
                        }
                    }catch(err){
                        const isCanceled = err && (err.name === 'CanceledError' || err.code === 'ERR_CANCELED' || err.message === 'canceled');
                        if (!isCanceled) {
                            this.$toast.add({ severity: 'error', summary: 'Error', detail: err && err.message ? err.message : String(err), life: 120000});
                        }
                    }finally{
                        this.loadingChart = false;
                        this._documentController = null;
                    }
                },

                getPemerosesanDocumentWo(){
                    var self = this;
                    this.$emit('block-ui');

                    var data = {
                        monthDate : this.monthYear3 != null ? new Date(this.monthYear3) : null
                    };
    
                    this.$axios.post(this.$API_URL + this.dataUrl + "pemerosesandocumentwo", data)
                        .then((response) => {
                            if(response && response.data.success){
                                this.dataWO = response.data.data;
                                self.$emit('unblock-ui');
    
                            }else{
                                self.$emit('unblock-ui');
                            }
                        })
                        .catch(function(err){
                            self.$emit('unblock-ui');
                            
                        });
                },
                // Debounced trigger to refresh progress data when filters change
                triggerGetProgressWO(delay = 150){
                    if(this._progressTimer) clearTimeout(this._progressTimer);
                    if (!delay || delay <= 0) {
                        // immediate
                        this.getProgressWO();
                        return;
                    }
                    this._progressTimer = setTimeout(() => {
                        try{ this.getProgressWO(); } catch(e){}
                    }, delay);
                },
                triggerGetOutstandingWO(delay = 150){
                    if(this._outstandingTimer) clearTimeout(this._outstandingTimer);
                    if (!delay || delay <= 0) {
                        // immediate
                        this.getOutStandingWO();
                        return;
                    }
                    this._outstandingTimer = setTimeout(() => {
                        try{ this.getOutStandingWO(); } catch(e){}
                    }, delay);
                },
                triggerGetProgressDocument(delay = 150){
                    if(this._progressDocumentTimer) clearTimeout(this._progressDocumentTimer);
                    if (!delay || delay <= 0) {
                        // immediate
                        this.getProgressDocument();
                        return;
                    }
                    this._progressDocumentTimer = setTimeout(() => {
                        try{ this.getProgressDocument(); } catch(e){}
                    }, delay);
                },
            },
            watch: {
                monthYear(newVal, oldVal){
                    // when month/year changed programmatically, refresh
                    this.triggerGetProgressWO();
                },
                monthYearFrom2(newVal, oldVal){
                    this.triggerGetProgressDocument();
                },
                monthYearTo2(newVal, oldVal){
                    this.triggerGetProgressDocument();
                },
                monthYear2(newVal, oldVal){
                    // ensure changes to the second calendar also trigger document refresh
                    this.triggerGetProgressDocument();
                },
                // ensure clearing or programmatic changes to these fields also refresh the WO progress
                monthYearFrom(newVal, oldVal){
                    this.triggerGetProgressWO();
                },
                monthYearTo(newVal, oldVal){
                    this.triggerGetProgressWO();
                },
                // monthYear3 watcher removed to avoid duplicate triggers;
                // @date-select now calls `onChangeMonthYear3` directly.
                // location changes are handled by `onLocationChange` to avoid duplicate triggers
                company_code(newVal, oldVal){
                    // when company changed, refresh progress
                    this.triggerGetProgressWO();
                    this.triggerGetOutstandingWO();
                }
            },
            mounted(){
                let date= new Date();
                let getMonth = date.getMonth() + 1;
                if(getMonth == 1){
                    this.month1 = "Januari";
                    this.month = "01";
                }
                else if(getMonth == 2){
                    this.month1 = "Februari";
                    this.month = "02";
                }
                else if(getMonth == 3){
                    this.month1 = "Maret";
                    this.month = "03";
                }
                else if(getMonth == 4){
                    this.month1 = "April";
                    this.month = "04";
                }
                else if(getMonth == 5){
                    this.month1 = "Mei";
                    this.month = "05";
                }
                else if(getMonth == 6){
                    this.month1 = "Juni";
                    this.month = "06";
                }
                else if(getMonth == 7){
                    this.month1 = "Juli";
                    this.month = "07";
                }
                else if(getMonth == 8){
                    this.month1 = "Agustus";
                    this.month = "08";
                }
                else if(getMonth == 9){
                    this.month1 = "September";
                    this.month = "09";
                }
                else if(getMonth == 10){
                    this.month1 = "Oktober";
                    this.month = "10";
                }
                else if(getMonth == 11){
                    this.month1 = "November";
                    this.month = "11";
                }
                else if(getMonth == 12){
                    this.month1 = "Desember";
                    this.month = "12";
                }

                if(!this.$store.getters.isAuthenticated){
                    this.$router.push({ name: "Login", params: { sessionExpired: true} });
                }

                // Register datalabels plugin only once to avoid duplicate rendering
                if (!Chart.__datalabels_registered) {
                    try {
                        Chart.register(ChartDataLabels);
                        Chart.__datalabels_registered = true;
                    } catch (e) {
                        // if registration fails for any reason, ignore to avoid breaking the UI
                    }
                }
                this.$nextTick(() => {
                    const child1 = this.$refs.locationSelect1;
                    if (child1 && child1.dataModel && typeof child1.dataModel === 'object') {
                        this.onLocationChange(child1.dataModel);
                    } else {
                        this.onLocationChange(this.location_code);
                    }

                    const child2 = this.$refs.locationSelect2;
                    if (child2 && child2.dataModel && typeof child2.dataModel === 'object') {
                        this.onLocationChange2(child2.dataModel);
                    } else {
                        this.onLocationChange2(this.location_code2);
                    }

                    const child3 = this.$refs.locationSelect3;
                    if (child3 && child3.dataModel && typeof child3.dataModel === 'object') {
                        this.onLocationChange3(child3.dataModel);
                    } else {
                        this.onLocationChange3(this.location_code3);
                    }
                    // trigger initial document fetch is handled by onLocationChange3 above

                    // also trigger outstanding WO load for the second panel on initial mount
                    try{ this.triggerGetOutstandingWO(0); } catch(e){}
                     this.getPemerosesanDocumentWo();
                });
            },
            beforeDestroy(){
                if(this._progressTimer) clearTimeout(this._progressTimer);
                if(this._progressController){ try{ this._progressController.abort(); } catch(e){} }
            },
            beforeUnmount(){
                if(this._progressTimer) clearTimeout(this._progressTimer);
                if(this._progressController){ try{ this._progressController.abort(); } catch(e){} }
            },
        }
    
    </script>
    
    <style scoped>
        h3 {
            margin: 40px 0 0;
        }
    
        ul {
            list-style-type: none;
            padding: 0;
        }
    
        li {
            display: inline-block;
            margin: 0 10px;
        }
    
        a {
            color: #42b983;
        }

        .dashboard {
      display: grid;
      grid-template-columns: repeat(2, 1fr);
      gap: 50px;    
    }

    .cards {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      width: 250px;
      padding: 10px;
      border-radius: 5px;
      box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
      color: #333;
      font-weight: bold;
    }

    .wo-creation { background-color: #d9d9d9; }
    .wo-progressing { background-color: #c6e6c3; }
    .release-approval { background-color: #f5e8b0; }
    .closing-approval { background-color: #f5d98a; }

    .title {
      text-align: center;
      font-size: 16px;
      margin-bottom: 10px;
    }

    .label {
      font-size: 12px;
    }

    .value {
      font-size: 24px;
    }

        /* Make chart and controls full width inside this component */
        .status-block {
            width: 100%;
            box-sizing: border-box;
        }
        .chart-wrapper {
            width: 100%;
        }
        .chart-wrapper :deep(canvas) {
            width: 100% !important;
            height: 420px !important;
        }

        .pie-grid .card {
            padding: 1rem;
            min-height: 340px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
        }

        .pie-grid .card :deep(canvas) {
            width: 100% !important;
            max-width: 480px;
            height: 320px !important;
        }

        /* Filter alignment styles */
        .filter-row {
            display: flex;
            gap: 1rem;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            box-sizing: border-box;
        }
        .filter-item {
            display: flex;
            align-items: center;
            gap: 0.5rem;
            min-width: 0;
            flex: 1 1 300px;
        }
        .filter-label {
            width: 120px;
            display: inline-block;
            text-align: left;
            margin-top: 0.2rem;
        }
        .full-width {
            width: 100%;
        }
        /* Force PrimeVue/child inputs to expand to container width */
        .full-width :deep(.p-inputtext),
        .full-width :deep(.p-dropdown),
        .full-width :deep(.p-calendar),
        .full-width :deep(.p-autocomplete),
        .full-width :deep(.p-inputnumber) {
            width: 100% !important;
            box-sizing: border-box;
        }

        /* Make card use available width and avoid max-width constraints */
        .card {
            width: 100% !important;
            max-width: none !important;
        }

        /* Ensure the status block uses full internal width */
        .status-block {
            width: 100% !important;
            padding: 1rem !important;
            box-sizing: border-box;
        }
        /* Two column layout for document charts (strong selectors) */
        .two-cols {
            display: grid !important;
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 1rem !important;
            align-items: start !important;
        }
        .two-cols .col-block {
            min-width: 0 !important; /* prevent children from forcing column to wrap */
            width: 100% !important;
        }
        /* Specific height for the document bar chart canvas */
        .document-chart-wrapper :deep(canvas) {
            width: 100% !important;
            height: 480px !important;
        }
        /* Specific height for the document on-progress bar chart canvas */
        .document-onprogress-chart-wrapper :deep(canvas) {
            width: 100% !important;
            height: 480px !important;
        }
        /* Specific height for the document Total & Total_Hari bar chart canvas (match above charts) */
        .document-total-days-chart-wrapper :deep(canvas) {
            width: 100% !important;
            height: 480px !important;
        }
    </style>
    